{
  "toast": {
    "crossDockStaged": "Cross-dock staged",
    "crossDockCompleted": "Cross-dock terminé",
    "cycleCountCreated": "Cycle count créé",
    "countRecorded": "Count enregistré",
    "cycleCountCompleted": "Cycle count terminé",
    "dockAppointmentScheduled": "Dock appointment scheduled",
    "checkedIn": "Checked in",
    "scanRecorded": "Scan enregistré",
    "putawayConfirmed": "Putaway confirmed",
    "pickConfirmed": "Pick confirmed",
    "pickListCreated": "Pick list créé",
    "packAndDispatchCompleted": "Pack and dispatch terminé",
    "warehouseCreated": "Warehouse créé",
    "zoneCreated": "Zone créé",
    "binCreated": "Bin créé",
    "transferCreated": "Transfer créé",
    "transferSubmittedForApproval": "Transfer soumis pour approbation",
    "transferCancelled": "Transfer annulé",
    "waveCreated": "Wave créé",
    "waveReleased": "Wave released",
    "transferAction": "Transfert {{action}}"
  },
  "errors": {
    "failedToLoadCrossDock": "Échec du chargement de cross-dock",
    "stageCrossDockFailed": "Échec de stage cross-dock",
    "completeCrossDockFailed": "Échec de complete cross-dock",
    "failedToLoadCounts": "Échec du chargement de counts",
    "failedToLoadCountLines": "Échec du chargement de count lines",
    "createCycleCountFailed": "Échec de create cycle count",
    "recordCountFailed": "Échec de record count",
    "failedToLoadDockAppointments": "Échec du chargement de dock appointments",
    "scheduleFailed": "Échec de schedule",
    "checkInFailed": "Échec de check-in",
    "failedToLoadLaborMetrics": "Échec du chargement de labor metrics",
    "failedToLoadTasks": "Échec du chargement de tasks",
    "scanFailed": "Échec de scan",
    "putawayFailed": "Échec de putaway",
    "pickFailed": "Échec de pick",
    "failedToLoadPutawayTasks": "Échec du chargement de putaway tasks",
    "failedToLoadPickLists": "Échec du chargement de pick lists",
    "failedToLoadTransfers": "Échec du chargement de transfers",
    "failedToLoadPicks": "Échec du chargement de picks",
    "createPickFailed": "Échec de create pick",
    "confirmPickFailed": "Échec de confirm pick",
    "packDispatchFailed": "Échec de pack/dispatch",
    "failedToLoadWarehouses": "Échec du chargement de warehouses",
    "failedToLoadZonesBins": "Échec du chargement de zones/bins",
    "createWarehouseFailed": "Échec de create warehouse",
    "createZoneFailed": "Échec de create zone",
    "createBinFailed": "Échec de create bin",
    "createTransferFailed": "Échec de create transfer",
    "submitFailed": "Échec de la soumission",
    "cancelFailed": "Échec de l'annulation",
    "failedToLoadWaves": "Échec du chargement de waves",
    "createWaveFailed": "Échec de create wave",
    "releaseWaveFailed": "Échec de release wave",
    "transferActionFailed": "Échec du transfert {{action}}"
  },
  "pages": {
    "crossDockStaging": "Cross-dock staging",
    "cycleCounts": "Cycle counts",
    "warehouseWms": "Entrepôt (WMS)",
    "warehouseDetails": "Entrepôt details",
    "warehouses": "Entrepôts",
    "openPutaway": "Open putaway",
    "floorOperationsPicksTransfersAndMovement": "Floor operations, picks, transfers, et movement activity pour votre entrepôts",
    "dockScheduling": "Dock scheduling",
    "laborMetrics": "Labor indicateurs",
    "wmsMobile": "WMS Mobile",
    "floorTasksForPutawayAndPicking": "Floor tasks pour putaway et picking",
    "floorOperations": "Floor operations",
    "pickPackDispatch": "Pick / pack / dispatch",
    "warehouseSetup": "Entrepôt setup",
    "warehouseTransfers": "Entrepôt transfers",
    "wavePicking": "Wave picking",
    "dockIdsHint": "Les ID de quai référencent les portes physiques configurées dans le référentiel d'entrepôt (utilisez l'ID de la configuration).",
    "selectOpenPickLists": "Sélectionnez les listes de picking ouvertes à regrouper :",
    "pickTaskLine": "Tâche {{id}} : {{product}} · qtê {{quantity}} ({{status}})"
  },
  "breadcrumbs": {
    "warehouse": "Entrepôt",
    "transfers": "Transferts",
    "setup": "Configuration",
    "dock": "Quai",
    "crossDock": "Cross-dock",
    "cycleCounts": "Comptages cycliques",
    "picks": "Pickings",
    "waves": "Vagues"
  },
  "headings": {
    "scheduleAppointment": "Planifier un rendez-vous",
    "stageInboundOutbound": "Préparer entrant → sortant",
    "newCycleCount": "Nouveau comptage cyclique",
    "linesForCount": "Lignes — comptage n°{{countId}}",
    "createPickList": "Créer une liste de picking",
    "createWave": "Créer une vague"
  },
  "permissions": {
    "scheduleDock": "L'autorisation de réception est requise pour planifier des rendez-vous de quai.",
    "stageCrossDock": "L'autorisation de réception est requise pour préparer le cross-dock.",
    "createCycleCounts": "L'autorisation admin entrepôt est requise pour créer des comptages cycliques.",
    "createAndConfirmPicks": "L'autorisation de picking est requise pour créer et confirmer les pickings."
  },
  "placeholders": {
    "select": "Sélectionner…"
  },
  "empty": {
    "noDockAppointments": "Aucun rendez-vous de quai.",
    "noCrossDockStaging": "Aucun enregistrement de cross-dock.",
    "noActiveCycleCounts": "Aucun comptage cyclique actif. Créez-en un pour commencer.",
    "noOpenPickLists": "Aucune liste de picking ouverte.",
    "noWavesYet": "Aucune vague pour le moment."
  },
  "labels": {
    "warehouse": "Entrepôt",
    "product": "Produit *",
    "quantity": "Quantité",
    "productOptionalLine": "Produit (optional line)",
    "physicalQuantity": "Physical quantity",
    "dockId": "Dock ID",
    "carrier": "Carrier",
    "startLocal": "Start (local)",
    "endLocal": "End (local)",
    "day": "Day",
    "barcode": "Code-barres",
    "targetBinIdPutaway": "Target bin ID (putaway)",
    "targetBinIdOptional": "Target bin ID (facultatif)",
    "scanBarcode": "Scan barcode",
    "pickedQtyConfirm": "Picked qty (confirm)",
    "carrierRefDispatch": "Carrier ref (dispatch)",
    "code": "Code",
    "name": "Nom",
    "type": "Catégorie",
    "zoneCode": "Zone code",
    "zoneName": "Zone name",
    "binCode": "Bin code",
    "fromWarehouse": "From entrepôt",
    "toWarehouse": "To entrepôt"
  },
  "formActions": {
    "addWarehouse": "Ajouter un entrepôt",
    "addZone": "Ajouter une zone",
    "addBin": "Ajouter un emplacement",
    "schedule": "Planifier",
    "stage": "Préparer",
    "createCount": "Créer le comptage",
    "createPick": "Créer le picking",
    "createWave": "Créer la vague"
  },
  "transfers": {
    "sections": {
      "createTransfer": "Créer un transfert"
    },
    "permissionRequired": "L'autorisation de transfert est requise pour créer des transferts.",
    "placeholders": {
      "select": "Sélectionner..."
    },
    "actions": {
      "createTransfer": "Créer le transfert",
      "submit": "Soumettre",
      "dispatch": "Expédier",
      "receive": "Réceptionner"
    },
    "actionPast": {
      "dispatch": "expédié",
      "receive": "reçu"
    },
    "empty": {
      "noOpenTransfers": "Aucun transfert ouvert."
    }
  },
  "setup": {
    "sections": {
      "createWarehouse": "Créer un entrepôt",
      "zones": "Zones",
      "bins": "Emplacements"
    },
    "warehouseTypes": {
      "central": "Central",
      "store": "Magasin",
      "transit": "Transit",
      "returns": "Retours",
      "virtual": "Virtuel"
    },
    "placeholders": {
      "selectWarehouse": "Sélectionner un entrepôt…"
    }
  },
  "listActions": {
    "recordScan": "Enregistrer le scan",
    "checkIn": "Enregistrer l'arrivée",
    "complete": "Terminer",
    "start": "Démarrer",
    "record": "Enregistrer",
    "confirmPick": "Confirmer le picking",
    "packDispatch": "Emballer et expédier",
    "release": "Libérer"
  }
}
